<template>
  <parallax-container>
    <div class="films">
      <Header colorIcons="#9d99a1" />
      <div class="films__text-container">
        <div class="films__return" @click="goBack">
          <span class="arrow" />
          Powrót
        </div>
        <div class="films__list">
          <div class="films__player" v-for="(player,index) in store.films" :key="index">
            <div class="films__frame-container">
              <!-- <video loop controls="true" width='100%' height='100%' :src="player.src" type='video/mp4' playsinline allowfullscreen></video> -->
              <iframe :src="player.src" frameborder="0" width='100%' height='100%' allowfullscreen></iframe>
            </div>
            <div class="films__info">
              <h2 class="films__info-title">{{player.title}}</h2>
              <p class="films__info-lead">{{player.lead}}</p>
            </div>
          </div>
        </div>
        <div class="films__scroll" @mouseenter="scrollDown" @mouseleave="scrollBlock">
          <div class="films__scroll-arrow">></div>
          <div class="films__scroll-text">przewijaj treść</div>
        </div>
      </div>
      <div class="films__photo-container">
        <parallax-element
          :parallaxStrength="10"
          :type="'translation'"
          class="films__photo"
          :style="{ 'background-image': 'url(' + store.photoImage + ')' }"
        >
        </parallax-element>
        <div class="films__photo-container-desc">
          {{store.photoImage_author}}
        </div>
      </div>
    </div>
  </parallax-container>
</template>

<script>
import store from "../../store/index.js";
import Header from "../Header/Header";

import VueMouseParallax from "vue-mouse-parallax";
import { setInterval, clearInterval } from "timers";

export default {
  name: "Films",
  components: {
    store,
    Header
  },
  data() {
    return {
      store: store.state[String(this.$route.params.name)]
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    scrollDown() {
      this.intervalID = setInterval(() => {
        const list = document.querySelector(".films__list");
        list.scroll(0, list.scrollTop + 2);
      }, 10);
    },
    scrollBlock() {
      clearInterval(this.intervalID);
    }
  }
};
</script>

<style lang="scss" scoped>
.films {
  background-color: #3e3c40;
  display: flex;
  justify-content: space-between;

  &__return {
    font-weight: bold;
    font-size: 2rem;
    font-family: "Oswald", sans-serif;
    text-transform: uppercase;
    color: #3e3c40;
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 13rem;

    .arrow {
      display: inline-block;
      height: 1rem;
      width: 6rem;
      background: url("./assets/arrow.png");
      background-size: cover;
      background-position: center;
      margin-right: 0.5rem;
      padding-left: 0.5rem;
    }
  }

  &__text-container {
    padding-top: 5%;
    padding-left: 1rem;
    background-color: #fff;
    width: 38%;
    margin-left: 8%;
    min-height: 100vh;
    z-index: 2;
  }
  &__photo-container-desc {
    position: absolute;
    bottom: 23%;
    left: 2%;
    color: rgba(255,255,255,0.6);
  }
  &__text-container:hover {
    ::-webkit-scrollbar {
      width: 8px;
    }
  }

  &__list {
    margin-top: 4vh;
    height: 75vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  &__player {
    max-width: 32rem;
    margin-bottom: 1.5rem;
  }

  &__frame-container {
    iframe {
      width: 100%;
      height: 18rem;
    }
  }

  &__info {
    &-title {
      font-size: 1.3rem;
      font-family: "Poppins", sans-serif;
      font-weight: 500;
      line-height: 1.5rem;
      margin: 1rem 0;
      width: 70%;
      color: #3e3c40;
    }

    &-lead {
      color: #3e3c40;
      font-family: "Poppins", sans-serif;
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
  }

  &__content-title {
    font-family: "Poppins", sans-serif;
    line-height: 1.4rem;
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: #3e3c40;
  }
  &__content-lead {
    font-family: "Poppins", sans-serif;
    line-height: 1.2rem;
    font-size: 0.8rem;
    color: #3e3c40;
  }

  &__scroll {
    display: flex;
    padding-top: 1rem;
    align-items: center;
    cursor: pointer;
    max-width: 10rem;
  }
  &__scroll-arrow {
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    width: 21px;
    height: 21px;
    transform: rotate(90deg);
    border: 1px solid black;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
  }
  &__scroll-text {
    font-family: "Poppins", sans-serif;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #717073;
  }

  &__photo-container {
    width: 54%;
    display: flex;
    position: relative;
    animation-name: showPhoto;
    animation-duration: 4s;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;

    @media (max-width: 1024px) {
      animation: none;
    }
  }

  &__photo {
    height: 80%;
    width: 100%;
    background-position: center;
    background-size: cover;
  }
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #a9c9b8;
}

@keyframes showPhoto {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opaciy: 1;
    transform: translateX(0);
  }
}
</style>
